import "@/styles/globals.css";

import { ThemeProvider } from "@norican/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { App } from "@/App";
import { queryClient } from "@/lib/api";
import { ThemeChoiceProvider } from "@/lib/theme";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* The choice lives outside the design system's provider and is handed
          in: ThemeProvider owns the palettes, this owns which one is on. */}
      <ThemeChoiceProvider>
        {(theme) => (
          <ThemeProvider theme={theme} density="comfortable">
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ThemeProvider>
        )}
      </ThemeChoiceProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
);
